import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import styles from "./UsersList.module.css";
import UserItem from "../UserItem";

/**
 * Interactive component. Scrollable list of all users with a header.
 */
export function UsersList({ users }) {
  const history = useHistory();

  const handleRedirect = () => {
    history.push("/dreamstream/user/details");
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.headerGrid}>
          <div className={styles.headerItem}>Name</div>
          <div className={styles.headerItem}>IBO #</div>
          {/* <div className={styles.headerItem}>Dreamstream ID</div> */}
          <div className={styles.headerItem}>Pin</div>
          <div className={styles.headerItem}>Status</div>
        </div>

        <div className={styles.usersContainer}>
          {users.map((user, index) => (
            <div
              key={index}
              className={
                index % 2 === 0 ? styles.backgroundWhite : styles.backgroundGray
              }
            >
              <UserItem
                eventMemberInfo={user}
                onClick={() => handleRedirect()}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

UsersList.propTypes = {
  users: PropTypes.arrayOf(PropTypes.object),
};
